import React, { useEffect, useState } from 'react'
import Page from '../../component/Page'
import './budgetYears.scss'
import api from '../../api/api'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material'
import { SETTING_CONFIG } from './config.'
import Swal from 'sweetalert2'

export default function BudgetYears() {
    const [detail, setDetail] = useState([])
    const [name, setName] = useState('')
    const [BudgetYear, setBudgetYear] = useState('')
    const [Status, setStatus] = useState('Y')
    const [data, setData] = useState()
    const [open, setOpen] = useState(false)
    const [Check, setCheck] = useState(false)
    const [Check2, setCheck2] = useState(false)
    const [CheckText, setCheckText] = useState('')
    const getItem = async () => {
        const res = await api.get(`dbms/budget-years?name=${name}`)
        const data = await res.data.result
        if (res.data.status === true) {
            setDetail(data)
        }
    }
    useEffect(() => {
        getItem()
    }, [name])
    const Open = (x) => {

        setBudgetYear(x?.BudgetYear)
        if (x?.BudgetYearId) {
            setCheck2(true)
        }

        setData(x)
        setStatus(x?.Status || 'Y')
        setOpen(true)
    }
    const Close = () => {
        setData()
        setOpen(false)
        setBudgetYear('')
        setStatus('Y')
        setCheck(false)
        setCheck2(false)

    }


    return (
        <Page>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-4 col-sm-12">
                        <label class="title-content mb-4">
                            ปีงบประมาณ
                        </label>

                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-lg-4">
                        <div class="d-flex justify-content-between align-items-center ">
                            <div class="">
                                <input value={name} onChange={e => setName(e.target.value)} class="form-control" type="text" placeholder="ค้นหา ปีงบประมาณ" />
                            </div>
                            <div class="group-add cp"  style={{cursor:'pointer'}} onClick={() => Open()}>
                                เพิ่มปีงบประมาณ
                            </div>


                        </div>

                        <div class="menu-list table-responsive-sm mt-3">
                            {detail?.map((x, i) => (
                                <div class="menu menu-row" onClick={() => Open(x)}>

                                    <div class="menu">
                                        {x?.BudgetYear}
                                    </div>

                                </div>
                            ))}


                        </div>
                    </div>


                </div>
            </div >
            <Dialog
                open={open}
                onClose={Close}
                fullWidth
                maxWidth='md'
            >
                <DialogTitle id="alert-dialog-title">

                </DialogTitle>
                <DialogContent>
                    <div class="row" style={{ marginBottom: "20px" }}>

                        <div class="col-lg-12 col-md-12">
                            <label class="labelInput">ปีงบประมาณ</label>

                            <Box className={`backgroundField ${CheckText !== 'สามารถใช้ปีงบประมาณนี้ได้' && Check ? 'error' : ''}`} sx={{ marginTop: "10px" }}>
                                <TextField value={BudgetYear} onChange={e => {

                                    setBudgetYear(e.target.value)
                                }} variant="standard" fullWidth
                                    onBlur={e => {

                                        const check = detail?.find((x) => x?.BudgetYear === e.target.value)
                                        if (check) {
                                            setCheck(true)
                                            setCheckText('ปีงบประมาณซ้ำกันในระบบ')
                                            setCheck2(false)
                                        } else {
                                            setCheck(true)
                                            if (e.target.value.length < 4) {
                                                setCheckText('กรุณากรอกเลขปีงบประมาณ 4 หลัก')
                                                setCheck2(false)
                                            } else {
                                                setCheckText('สามารถใช้ปีงบประมาณนี้ได้')
                                                setCheck2(true)
                                            }

                                        }

                                    }}
                                    inputProps={{ maxLength: 4 }}
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    InputProps={{
                                        disableUnderline: true,
                                    }}

                                />
                            </Box>
                            {Check && <span style={{ color: CheckText === 'สามารถใช้ปีงบประมาณนี้ได้' ? 'green' : 'red', fontSize: '12px', }}>{CheckText}</span>}
                        </div>

                    </div>
                    <div class="row">

                        <RadioGroup row value={Status || ''} onChange={e => setStatus(e.target.value)}>
                            <FormControlLabel value="Y" control={<Radio />} label="ใช้งาน" />
                            <FormControlLabel value="N" control={<Radio />} label="ไม่ใช้งาน" />
                        </RadioGroup>

                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' sx={{ width: '120px' }}  onClick={Close}>ปิด</Button>
                    <Button variant='contained' sx={{ width: '120px' }}  onClick={() => {
                        const body = {
                            BudgetYearId: data?.BudgetYearId || null,
                            BudgetYear: BudgetYear,
                            Status: Status,
                        }

                        async function budgetYearAdd() {

                            if (body?.BudgetYearId) {
                                const url = SETTING_CONFIG.requests.getBudgetYears.url + `/${body?.BudgetYear}`;
                                const res = await api.put(url, body)
                                const data = await res.data
                                if (data.status === true) {
                                    getItem()
                                    Close()
                                    Swal.fire(
                                        'ทำรายการสำเร็จ',
                                        '',
                                        'success'
                                    )
                                }
                            } else {

                                const res = await api.post(SETTING_CONFIG.requests.getBudgetYears.url, body)
                                const data = await res.data
                                if (data.status === true) {
                                    getItem()
                                    Close()
                                    Swal.fire(
                                        'ทำรายการสำเร็จ',
                                        '',
                                        'success'
                                    )
                                }
                            }
                        }
                        if (Check2) {
                            budgetYearAdd()
                        }
                    }} >
                        บันทึก
                    </Button>
                </DialogActions>
            </Dialog>
        </Page >
    )
}
